import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GTM } from './_services/gtm.service';
import { filter, pairwise, Subscription } from 'rxjs';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { HistoryService } from './_services/history.service';

@Component({
  selector: 'ng-casto-root',
  template: `
    <ng-casto-header context="customer"></ng-casto-header>
    <router-outlet></router-outlet>
    <ng-casto-modals></ng-casto-modals>
  `,
})
export class AppComponent implements OnInit, OnDestroy {
  routeHistorySubscription: Subscription | undefined;
  routerSubscription: Subscription | undefined;

  constructor(public gtm: GTM,
    private router: Router,
    private titleService: Title,
    private historyService: HistoryService) {
    this.gtm.init();

    this.routeHistorySubscription = this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {
        const previousUrl = events[0].urlAfterRedirects;
        const previousTitle = this.titleService.getTitle();
        this.historyService.setPreviousPage({
          url: previousUrl,
          name: previousTitle
        });
      });

    this.routerSubscription = this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      setTimeout(() => {
        const pageName = this.titleService.getTitle();
        const virtualPath = e.urlAfterRedirects;
        const pageType = this.getPageTypeFromUrl(virtualPath);
        const previousPage = this.historyService.getPreviousPage();
        const previous = previousPage
          ? { name: previousPage.name, type: 'page' }
          : undefined;

        this.gtm.trackPage(pageName, pageType, virtualPath, previous);
      }, 3000);
    });
  }

  ngOnInit(): void {
    console.log('Version actuelle : ' + environment.version);
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  getPageTypeFromUrl(url: string): string {
    const cleanUrl = url.split('?')[0].split('#')[0];
    const segments = cleanUrl.split('/').filter(Boolean);

    if (segments.length === 0 || segments[0] === 'connexion') {
      return 'Homepage';
    }

    const first = segments[0];
    const second = segments[1] || '';

    if (['accueil', 'informations', 'historique', 'fidelite'].includes(first)) {
      return 'Mon Compte';
    }
    if (first === 'creation') {
      return 'Cr�ation';
    }

    if (first === 'clients') {
      if (['recherche', 'rechercheloyalty'].includes(second)) return 'Recherche';
      if (['creationCarte', 'modification'].includes(second) || second.startsWith('creationCarte')) return 'Cr�ation';
      if (second.startsWith('carte')) return 'Carte Client';
      if (second.startsWith('historique')) return 'Historique Client';
      if (second.startsWith('detailloyalty')) return 'Loyalty Client';
    }

    if (first === 'reporting') return 'Reporting';
    if (first === 'administration') return 'Administration';

    return 'Autre';
  }

}
